
export default function formatSocialNumber(value){
    if(value > 1000){
        let num = value/1000;
        return Math.round(num)+"k"
    }
    return value;
}